import { Component, OnInit, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { Organization } from '../Classes/OrganizationClass';
import { OrganizationService } from '../Services/OrganizationService';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs';
import { Headers, Http, Response, RequestOptions } from '@angular/http';

@Component({
  selector: 'Organization-Search',
  templateUrl: '../Organization/OrganizationSearch.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/fixedheader.css'],
  providers: [OrganizationService]
})

export class OrganizationSearchComponent implements OnInit {
  _Organization = new Organization();
  innerWidth: number;
  loading: boolean = false;
  QueryTenantID: any = [];
  QueryMessage: any = [];
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  SearchdropFirst: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'City', Text: 'City' },
    { Value: 'State', Text: 'State' },
    { Value: 'Status', Text: 'Status' }
  ]
  SearchdropSecond: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'City', Text: 'City' },
    { Value: 'State', Text: 'State' },
    { Value: 'Status', Text: 'Status' }
  ]
  //SearchExper: any[] = [
  //  { Value: 'Contains', Text: 'Contains' },
  //  { Value: 'Exact', Text: 'Exact' },
  //]
  GetOrganizationResult: any = [];
  @ViewChild("inputBox") _el: ElementRef;
  @ViewChild("inputBoxtext") _el1: ElementRef;
  RoleID: string;
  StateData: string;
  constructor(private _OrgService: OrganizationService, private _router: Router, private Activeroute: ActivatedRoute, public toastr: ToastsManager, vcr: ViewContainerRef,
    private http: Http) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
  }
  ngOnInit() {
    this.ChangeHeadeFooterColor();
    this.RoleID = sessionStorage.getItem('RoleID');
    let val = localStorage.getItem('SearchtextFirst');
    if (val != null) {
      let val2 = "";
      this._OrgService.Get_OrgDetails(val, val2).subscribe(res => {
        var data = res;
        if (!data.Message) {
          this.GetOrganizationResult = data;
          this.loading = false;
        }
        else {
          this.toastr.error(data.Message);
          this.loading = false;
        }
      })
    }
    this._Organization.SearchdropFirst = "-1";
    this._Organization.SearchdropSecond = "-1";
    this._Organization.SearchMatchesFirst = "Contains";
    this._Organization.SearchMatchesSecond = "Contains";
  }

  public GetOrgSearchAutocomplete = (SearchStr: any, SearchdropName: any): Observable<any[]> => {
    if (SearchStr) {
      let OrgDetails = { "mQuery": JSON.stringify(SearchdropName), "SearchDropName": JSON.stringify(SearchStr) };
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
      return this.http.get('api/Organization/GetOrgSearchAutocomplete', options)
        .map(res => {
          let json = res.json();
          let jsonarray = json;
          return jsonarray;
        })
    }
    else {
      return Observable.of([]);
    }
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  public FilterFirstChange(Searchdrop: string) {
    this.SearchdropSecond = [];
    let SearchdropFirstdata: any[] = this._Organization.SearchdropSecondList;
    for (let i = 0; i < SearchdropFirstdata.length; i++) {
      if (SearchdropFirstdata[i].Value != Searchdrop) {
        this.SearchdropSecond.push(SearchdropFirstdata[i]);
      }
      else {
        this.SearchdropFirst.slice(i, 1);
      }
    }
    this._Organization.SearchtextFirst = "";
    if (this._Organization.SearchdropFirst == "Status") {
      this._Organization.SearchtextFirst = "Active";
      this._Organization.SearchMatchesFirst = "Exact";
    }
    else { this._Organization.SearchMatchesFirst = "Contains";}
  }

  public FilterSecondChange(Searchdrop: string) {
    this.SearchdropFirst = [];
    let SearchdropSeconddata: any[] = this._Organization.SearchdropFirstList;
    for (let i = 0; i < SearchdropSeconddata.length; i++) {
      if (SearchdropSeconddata[i].Value != Searchdrop) {
        this.SearchdropFirst.push(SearchdropSeconddata[i]);
      }
      else {
        this.SearchdropSecond.slice(i, 1);
      }
    }
    this._Organization.SearchtextSecond = "";
    if (this._Organization.SearchdropSecond == "Status") {
      this._Organization.SearchtextSecond = "Active";
      this._Organization.SearchMatchesSecond = "Exact";
    }
    else { this._Organization.SearchMatchesSecond = "Contains"; }
  }

  public BtnSearch() {
    this.loading = true;
    var mQuery: string = "";
    if ((this._Organization.SearchdropFirst != "-1") || (this._Organization.SearchdropSecond != "-1")) {

      let pattern = new RegExp(/^[- a-z. 0-9 _ < > & $ % @ * ~ ! ^ + = : ; , | ( ) { } \/ ! # ]+$/i)
      /***********************First Drop Down ****************************************/
      if (this._Organization.SearchdropFirst != "-1") {

        if (this._Organization.SearchtextFirst != undefined && this._Organization.SearchtextFirst != "") {
            if (this._Organization.SearchMatchesFirst == "Contains") {
               mQuery = "where "  + this._Organization.SearchdropFirst + ' like ' + "'%" + this._Organization.SearchtextFirst + "%'";
            }
            else if (this._Organization.SearchMatchesFirst == "Exact") {
               mQuery += "where " + this._Organization.SearchdropFirst + ' = ' + "'" + this._Organization.SearchtextFirst + "'";
            }
        }

        else {
          /********* ShowWriteToastMessage ******/
          this.ShowWriteToastMessage();
          this.toastr.error('Please enter the ' + this._Organization.SearchdropFirst + '.');
          this.loading = false;
          /********* SetRightToastMessage ******/
          this.SetRightToastMessage();
          return;
        }
      }

      /***********************Second Drop Down ****************************************/
      if (this._Organization.SearchdropSecond != "-1") {

        if (this._Organization.SearchtextSecond != undefined && this._Organization.SearchtextSecond != "") {
          if (!this._Organization.SearchtextFirst) {
              if (this._Organization.SearchMatchesSecond == "Contains") {
                mQuery += "where " + this._Organization.SearchdropSecond + ' like ' + "'%" + this._Organization.SearchtextSecond + "%'";
              }
              else if (this._Organization.SearchMatchesSecond == "Exact") {
                mQuery += "where "  + this._Organization.SearchdropSecond + ' = ' + "'" + this._Organization.SearchtextSecond + "'";
              }
            
          }
          else {
            if (this._Organization.SearchdropSecond != "State") {
              if (this._Organization.SearchMatchesSecond == "Contains") {
                mQuery += "and "  + this._Organization.SearchdropSecond + ' like ' + "'%" + this._Organization.SearchtextSecond + "%'";
              }
              else if (this._Organization.SearchMatchesSecond == "Exact") {
                mQuery += "and " + this._Organization.SearchdropSecond + ' = ' + "'" + this._Organization.SearchtextSecond + "'";
              }
            }
            }
            }

        else {
          /********* ShowWriteToastMessage ******/
          this.ShowWriteToastMessage();
          this.toastr.error('Please enter the ' + this._Organization.SearchdropSecond + '.');
          this.loading = false;
          /********* SetRightToastMessage ******/
          this.SetRightToastMessage();
          return;
        }
      }
    }
    else {
      this.toastr.error('Please select at least one criteria.');
      this.loading = false;
      return;
    }
    console.log(mQuery);
    localStorage.setItem('SearchtextFirst', mQuery);
    var mQuerysecond = "";
    this._OrgService.Get_OrgDetails(mQuery, mQuerysecond).subscribe(res => {
      var data = res;
      if (!data.Message) {
        this.GetOrganizationResult = data;
        this.loading = false;
      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })
  }

  public RedirectToORgdetails() {
    this._router.navigate(['/OrganizationDetails', { pageName: btoa(JSON.stringify('OrgSearch'))}]);
  }

  EditOrganizationPage(TenantID: string) {
    this._router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(TenantID)), pageName: btoa(JSON.stringify('OrgSearch')) }]);
  }


  ShowWriteToastMessage() {
    if (this._Organization.SearchdropFirst == "Pname") {
      this._Organization.SearchdropFirst = "Org Name";
    }
    else if (this._Organization.SearchdropFirst == "lettercode") {
      this._Organization.SearchdropFirst = "Org Code";
    }
    else if (this._Organization.SearchdropSecond == "Pname") {
      this._Organization.SearchdropSecond = "Org Name";
    }
    else if (this._Organization.SearchdropSecond == "lettercode") {
      this._Organization.SearchdropSecond = "Org Code";
    }
  }

  SetRightToastMessage() {
    if (this._Organization.SearchdropFirst == "Org Name") {
      this._Organization.SearchdropFirst = "Pname";
    }
    else if (this._Organization.SearchdropFirst == "Org Code") {
      this._Organization.SearchdropFirst = "lettercode";
    }
    else if (this._Organization.SearchdropSecond == "Org Name") {
      this._Organization.SearchdropSecond = "Pname";
    }
    else if (this._Organization.SearchdropSecond == "Org Code") {
      this._Organization.SearchdropSecond = "lettercode";
    }
  }

  public ChangeStatus(Val: string) {
    if (Val == "Inactive") {
      Val = "Terminated";
      return Val;
    }
    else {
      Val = "Active";
      return Val;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Organization/OrganizationSearch.component.ts